<template>
    <div class="login-form">
        <div class="form border ">
            <router-link class="back-btn" :to="{ name: 'login' }">{{ $lang('TEXT_LOGIN') }}</router-link>
            <h1>{{ $lang('TEXT_REGISTER') }}</h1>
            <b-form @submit="onSubmit">
                <!-- <div class="form-group">
                <b-form-radio-group v-model="registerForm.type" plain name="plain-inline">
                    <b-form-radio value="email">{{$lang('電郵驗證')}}</b-form-radio>
                    <b-form-radio value="mobile">{{$lang('手機驗證')}}</b-form-radio>
                </b-form-radio-group>
            </div> -->
                <!-- 電郵驗證 -->
                <div v-show="registerForm.type === 'email'">
                    <b-form-group class="email">
                        <template slot="label">
                            <label></label>
                        </template>
                        <b-form-input v-model="registerForm.email" type="email" ref="email" name="email"
                            :class="errors.has('email') && 'is-invalid'" :placeholder="$lang('FIELD_EMAIL')"
                            v-validate="{ 'required': status, 'email': status }"></b-form-input>
                        <b-form-invalid-feedback :state="errors.has('email')">
                            {{ errors.first('email') }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group class="email">
                        <template slot="label">
                            <label></label>
                        </template>
                        <b-form-input v-model="registerForm.reemail" data-vv-as="email" type="email" name="reemail"
                            :class="errors.has('reemail') && 'is-invalid'" :placeholder="$lang('FIELD_REEMAIL')"
                            v-validate="{ 'required': status, 'confirmed': status ? 'email' : false }"></b-form-input>
                        <b-form-invalid-feedback :state="errors.has('reemail')">
                            {{ errors.first('reemail') }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </div>

                <!-- 手機驗證 -->
                <div v-show="registerForm.type === 'mobile'">
                    <b-form-group class="phone">
                        <template slot="label">
                            <label></label>
                        </template>
                        <b-form-input v-model="registerForm.mobile" type="text" name="phone"
                            :class="errors.has('phone') && 'is-invalid'" :placeholder="$lang('FIELD_PHONE')"
                            v-validate="{ 'required': !status, 'mobile': !status }"></b-form-input>
                        <b-form-invalid-feedback :state="errors.has('phone')">
                            {{ errors.first('phone') }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group class="verification authentication">
                        <template slot="label">
                            <label></label>
                        </template>
                        <b-form-input v-model="registerForm.smsCode" type="text" @change="checkCode" :state="codeState"
                            name="smsCode" :class="errors.has('smsCode') && 'is-invalid'"
                            :placeholder="$lang('FIELD_VERIFICATION')"
                            v-validate="{ 'required': !status }"></b-form-input>
                        <b-btn variant="info" @click="getCode" :disabled="disabled">
                            <span class="tip" v-if="!sendMsgDisabled && !reGet">{{ $lang('發送驗證碼') }}</span>
                            <span class="tip" v-if="!sendMsgDisabled && reGet">{{ $lang('重新獲取') }}</span>
                            <span class="tip" v-if="sendMsgDisabled">{{ rTime + $lang('秒後重新獲取') }}</span>
                        </b-btn>
                        <b-form-invalid-feedback :state="errors.has('smsCode')">
                            {{ errors.first('smsCode') }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </div>
                <!-- <b-form-group class="user_name">
                <template slot="label">
                    <label></label>
                </template>
                <b-form-input v-model="registerForm.username" type="text" name="username" :placeholder="$lang('FIELD_USERNAME')" :class="errors.has('username') && 'is-invalid' " v-validate="'required'"></b-form-input>
                <div class="text-left"><span class="text-primary">{{$lang('MUST_8_10_not_blank')}}</span></div>
                <b-form-invalid-feedback :state="errors.has('username')">
                    {{errors.first('username')}}
                </b-form-invalid-feedback>
            </b-form-group> -->
                <!-- <b-form-group class="pass_word">
                <template slot="label">
                    <label></label>
                </template>
                <b-form-input v-model="registerForm.password" ref="password" type="password" name="password" :class="errors.has('password') && 'is-invalid' " :placeholder="$lang('FIELD_PASSWORD')" v-validate="'required|password'"></b-form-input>
                <div class="text-left"><span class="text-primary">{{$lang('PWD_MUST_OVER_8')}}</span></div>
                <b-form-invalid-feedback :state="errors.has('password')">
                    {{errors.first('password')}}
                </b-form-invalid-feedback>
            </b-form-group> -->
                <!-- <b-form-group class="pass_word">
                <template slot="label">
                    <label></label>
                </template>
                <b-form-input v-model="registerForm.repassword" data-vv-as="password" type="password" name="repassword" :class="errors.has('repassword') && 'is-invalid' " :placeholder="$lang('FIELD_PASSWORD_AGAIN')" v-validate="'required|confirmed:password'"></b-form-input>
                <div class="text-left"><span class="text-primary">{{$lang('PWD_MUST_OVER_8')}}</span></div>
                <b-form-invalid-feedback :state="errors.has('repassword')">
                    {{errors.first('repassword')}}
                </b-form-invalid-feedback>
            </b-form-group> -->
                <b-form-group class="user_name">
                    <template slot="label">
                        <label></label>
                    </template>

                    <b-form-select v-model="registerForm.idType" name="idType"
                        :class="errors.has('idType') && 'is-invalid'" :placeholder="$lang('TITLE_ID_TYPE')">
                        <option value="" selected disabled hidden>{{ $lang('TITLE_ID_TYPE') }}</option>
                        <option :value="1">{{ $lang("TEXT_ID_TYPE_MACAO") }}</option>
                        <option :value="2">{{ $lang("TEXT_ID_TYPE_PASSPORT") }}</option>
                        <option :value="3">{{ $lang("TEXT_ID_TYPE_OTHER") }}</option>
                    </b-form-select>
                    <b-form-invalid-feedback :state="errors.has('idType')">
                        {{ errors.first("idType") }}
                    </b-form-invalid-feedback>

                </b-form-group>
                <b-form-group class="user_name">
                    <template slot="label">
                        <label></label>
                    </template>
                    <b-form-input :maxlength="registerForm.idType == 1 ? 8 : null" v-model="registerForm.idNum"
                        type="text" name="idNum" :class="errors.has('idNum') && 'is-invalid'"
                        :placeholder="registerForm.idType == 1 ? `${$lang('身份證號碼')}` : `${$lang('身份證號碼')}`"
                        v-validate="registerForm.idType == 1 ? {
                            required: true, idNumberRe, cycling_idNumber: false
                        }
                            : { required: true, cycling_idNumber: false, idNumberRe: false }"></b-form-input>
                    <b-form-invalid-feedback :state="errors.has('idNum')">
                        {{ errors.first("idNum") }}
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group class="captcha">
                    <b-form-input v-model="registerForm.captcha" name="captcha"
                        :class="errors.has('captcha') && 'is-invalid'" :placeholder="$lang('FILED_CAPTCHA')"
                        v-validate="{ 'required': !status }"></b-form-input>
                    <div class="captcha-invalid">
                        <b-img :src="captcha_url"></b-img>
                        <!-- {{$lang('Renew')}} -->
                        <a href="javascript:void(0)" class="reload_btn" @click="getCaptcha()"></a>
                    </div>
                    <!-- <template slot="label">
                    
                </template> -->
                    <b-form-invalid-feedback :state="errors.has('captcha')">
                        {{ errors.first('captcha') }}
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-button type="submit" class="register" variant="primary">{{ $lang('TEXT_REGISTER') }}</b-button>
            </b-form>
        </div>

    </div>
</template>

<script>

import {
    mapActions,
    mapGetters
} from 'vuex'
import LaddaBtn from '@/components/ladda/Ladda'
export default {
    components: {
        LaddaBtn
    },

    data() {
        return {
            registerForm: {
                type: "mobile",
                scene: 'regist',
                username: "",
                email: "",
                mobile: "",
                code: "",
                captcha: "",
                smsCode: "",
                idType: '1',
                idNum: '',

            },
            interval: null,
            codeState: null,
            loginLoading: false,
            reGet: false, // 重新获取
            rTime: 60, // 发送验证码倒计时
            sendMsgDisabled: false, // 发送验证码按钮状态
            disabled: false,
            tel: "",
            code: ""
        }
    },
    computed: {
        ...mapGetters('user', {
            captcha: 'captcha',
            captcha_url: 'captcha_url',
            sid: 'sid',
        }),
        status() {
            return this.registerForm.type === 'email'
        }
    },
    watch: {
        status(n) {
            console.log(n, this.registerForm.type)
        },
        'registerForm.idType': {
            handler(n) {
                this.registerForm.captcha = '';
                this.$validator.reset();
            }
        }
    },
    methods: {
        ...mapActions('user', ['register', 'getCaptcha']),
        onSubmit(evt) {
            evt.preventDefault()
            let params = {
                type: this.registerForm.type,
                mobile: this.registerForm.mobile,
                idType: this.registerForm.idType,
                smsCode: this.registerForm.smsCode,
                captcha: this.registerForm.captcha,
                sid: this.sid,
                idNum: this.registerForm.idNum
            }
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loginLoading = true;
                    this.register(params)
                        .then((resp) => {
                            this.loginLoading = false;
                            if (this.status) {
                                this.$router.push({
                                    name: 'waiting_confirm_mail',
                                    params: {
                                        hash: resp.data.hash
                                    }
                                })
                            } else {
                                this.$router.push({
                                    name: 'verification_mob'
                                })
                            }
                        }).catch((err) => {
                            if (err.code == 10001) {
                                err.data.errors.forEach(item => {
                                    let str = item.path;
                                    this.errors.add({
                                        field: str,
                                        msg: item.message
                                    })
                                    console.log(this.errors)
                                    this.getCaptcha();
                                })
                            }
                        })
                } else {
                    return false
                }
            })
        },
        sendCode(params) {
            return this.$apis.sendCode(params)
        },
        checkCode() {
            let params = {
                mobile: this.registerForm.mobile,
                code: this.registerForm.code,
                scene: this.registerForm.scene
            }
            this.$apis.checkCode(params).then(() => {
                this.codeState = true
            }).catch((err) => {
                this.errors.add({
                    field: "verificationCode",
                    msg: this.$lang(err.code)
                })
            })
        },
        getCode() {
            this.$validator.validate('phone').then((valid) => {
                if (valid) {
                    let rTime = this.rTime;
                    this.sendMsgDisabled = true;
                    this.disabled = true;
                    let params = {
                        mobile: this.registerForm.mobile,
                        scene: this.registerForm.scene,
                    }
                    this.sendCode(params);
                    //倒计时
                    this.interval = setInterval(() => {
                        if (--this.rTime <= 0) {
                            this.rTime = rTime;
                            this.sendMsgDisabled = false;
                            this.disabled = false;
                            this.reGet = true; // 重新获取按钮
                            clearInterval(this.interval);
                        }
                    }, 1000);
                }
            })
        }
    },
    created() {
        this.getCaptcha();
        this.$validator.extend('idNumberRe', {
            getMessage: () => this.$lang('INVALID_ID_NUMBER'),
            validate: value => /^[1|5|7]\d{6}(\d|[a-zA-Z])$/.test(value) && value.length === 8
        });
    }
}
</script>
